import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./Hero.css";

const Hero = () => {
  const navigate = useNavigate();
  return (
    <section id="hero" className="hero-section">
      {/* Background with gradient overlay */}
      <div className="hero-gradient-overlay" />

      {/* Animated background elements */}
      <div className="hero-background-elements">
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 90, 0],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "linear",
          }}
          className="bg-glow-purple"
        />
        <motion.div
          animate={{
            scale: [1.2, 1, 1.2],
            rotate: [90, 0, 90],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "linear",
          }}
          className="bg-glow-cyan"
        />
      </div>

      {/* Content */}
      <div className="hero-content">
        <div className="container hero-grid">
          {/* Left Column: Text */}
          <div className="hero-text-content">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="hero-title"
            >
              Build Skills That <br />
              <span className="text-gradient">Get You Hired.</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="hero-description"
            >
              Learn real-world skills with expert guidance and unlock global career opportunities.
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="hero-about-text"
              style={{ fontSize: "15px", color: "var(--muted-foreground)", marginBottom: "30px", maxWidth: "90%", lineHeight: "1.6" }}
            >
              Welsh Education is focused on building career-ready individuals through practical, industry-relevant skill programs. We help students gain real-world expertise that prepares them for today’s competitive job market.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="hero-cta"
            >
              <button
                className="btn-primary-gradient"
                onClick={() => navigate("/courses")}
              >
                Explore Skill Programs
                <ArrowRight className="cta-icon" />
              </button>
              <button
                className="btn-secondary-outline"
                onClick={() => navigate("/contact")}
              >
                Book Free Counseling
              </button>
            </motion.div>

            {/* Trust Strip */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="hero-trust-strip"
            >
              <div className="trust-item">
                <div className="trust-number">1000+</div>
                <div className="trust-label">Study Abroad Students</div>
              </div>
              <div className="trust-item">
                <div className="trust-number">50+</div>
                <div className="trust-label">Hiring Partners</div>
              </div>
              <div className="trust-item">
                <div className="trust-number">10+</div>
                <div className="trust-label">Global Destinations</div>
              </div>
            </motion.div>
          </div>

          {/* Right Column: Visual */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="hero-visual-content"
          >
            <div className="hero-image-wrapper">
              <img
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=800&auto=format&fit=crop"
                alt="Students collaborating"
                className="hero-image"
              />
              <div className="hero-image-glow"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
